module.exports = __webpack_public_path__ + "img/boton_observaciones.b6445090.svg";